import { IUser } from '@shared/common/interfaces';

export class LoadMembers {
    static readonly type = '[Member] Load Members';
    constructor(
        public channelId: string,
        public memberIds: string[],
    ) {}
}

export class LoadMembersSuccess {
    static readonly type = '[Member] Load Members Success';
    constructor(
        public channelId: string,
        public members: IUser[],
    ) {}
}

export class LoadMembersError {
    static readonly type = '[Member] Load Members Error';
    constructor(
        public channelId: string,
        public error: any,
    ) {}
}

// Utility Actions
export class ClearMembersForChannel {
    static readonly type = '[Member] Clear Members For Channel';
    constructor(public channelId: string) {}
}
